import { api } from "@/lib/api";

// --- Feature detection ---
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isPushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
// Su iOS le Web Push esistono solo nella PWA installata (standalone).
export const canUsePush = () => isPushSupported() && (!isIOS() || isStandalone());
export const needsIOSInstall = () => isIOS() && !isStandalone();

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

const EP_KEY = "orbit_push_endpoint";
export const savedEndpoint = () => localStorage.getItem(EP_KEY) || "";

// Attiva le notifiche: chiede permesso, crea la subscription, la salva sul backend.
// Da chiamare DIRETTAMENTE nel gestore del click sullo switch (gesto utente).
export async function enablePush() {
  if (needsIOSInstall()) { const e = new Error("ios-install"); e.code = "ios-install"; throw e; }
  if (!canUsePush()) { const e = new Error("unsupported"); e.code = "unsupported"; throw e; }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") { const e = new Error("denied"); e.code = "denied"; throw e; }
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys, user_agent: navigator.userAgent });
  localStorage.setItem(EP_KEY, json.endpoint);
  return json.endpoint;
}

export async function disablePush() {
  const endpoint = savedEndpoint();
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe();
  } catch (_) {}
  try { await api.post("/push/unsubscribe", { endpoint }); } catch (_) {}
  localStorage.removeItem(EP_KEY);
}

export async function pushStatus() {
  const endpoint = savedEndpoint();
  if (!endpoint) return false;
  try {
    const { data } = await api.get(`/push/status?endpoint=${encodeURIComponent(endpoint)}`);
    return !!data.enabled;
  } catch (_) { return false; }
}

// Presenza: informa il backend se questo dispositivo ha Orbit visibile/in primo piano.
export function sendPresence(visible) {
  const endpoint = savedEndpoint();
  if (!endpoint) return;
  api.post("/push/presence", { endpoint, visible }).catch(() => {});
}

// TEMPORANEO (diagnostica): invia una push di prova al solo dispositivo corrente.
export async function sendTestPush() {
  const endpoint = savedEndpoint();
  if (!endpoint) { const e = new Error("no-endpoint"); e.code = "no-endpoint"; throw e; }
  await api.post("/push/test", { endpoint });
}
